// extracted by mini-css-extract-plugin
module.exports = {"faqAccordion":"FAQ_faqAccordion__c0eUt","faqWrapper":"FAQ_faqWrapper__ZjS_m","colWrapper":"FAQ_colWrapper__Y_RVq","faqContent":"FAQ_faqContent__u_N0h"};